import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { loadScript } from "@/hooks/chart/helpers";
import { useDevice } from "@/redux/selectors/deviceSelector";
import { setIsChartReady } from "@/redux/actions/ui";
import { ChartEngine } from "@/hooks/chart/useChartEngine";

export const useTradeChartLoader = (engine: ChartEngine = "adv"): void => {
    const dispatch = useDispatch();
    const { platform: devicePlatform } = useDevice();
    const isDesktop = devicePlatform === "Desktop";

    useEffect(() => {
        if (engine !== "adv") {
            dispatch(setIsChartReady(true));
            return;
        }

        loadScript(
            `${window?.location.origin}/ChartUI/init/prochart.loader.min.js`,
            () => {
                // @ts-ignore
                const chartLoader = window?.ProChart_Loader();

                chartLoader.init.rootpath = window?.location?.origin;

                chartLoader.init.loadertemplates.push(
                    isDesktop
                        ? {
                            layout: "layout1",
                            template: "default",
                        }
                        : {
                            layout: "layout_mobile",
                            template: "default",
                        }
                );

                chartLoader.LoaderInitComplete = () => {
                    dispatch(setIsChartReady(true));
                };

                chartLoader.LoaderInitCombine();
            },
            "chart_loader_script"
        );
    }, []); // should be loaded only once, on app init
};
